import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
interface Props {
  onBack: () => void;
}
export function ImpressumPage({
  onBack
}: Props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="min-h-screen bg-[#020611] pt-32 pb-24" data-id="element-215">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-216">
        <motion.button onClick={onBack} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 text-muted hover:text-accent transition-colors mb-12 group" data-id="element-217">
          <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" data-id="element-218" />
          Zurück zur Startseite
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-219">
          <h1 className="text-3xl md:text-5xl font-heading font-bold leading-tight mb-12" data-id="element-220">
            Impressum
          </h1>

          <div className="space-y-10 text-foreground/90 leading-relaxed" data-id="element-221">
            <div data-id="element-222">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-223">
                Angaben gemäß § 5 TMG
              </h2>
              <p data-id="element-224">
                PEZULA Projects & Experts GmbH
                <br data-id="element-225" />
                Innungsstr. 5<br data-id="element-226" />
                21244 Buchholz i.d.N.
              </p>
            </div>

            <div data-id="element-227">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-228">
                Vertreten durch
              </h2>
              <p data-id="element-229">Sven Schulte (Geschäftsführer)</p>
            </div>

            <div data-id="element-230">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-231">
                Kontakt
              </h2>
              <p data-id="element-232">
                E-Mail:{' '}
                <a href="mailto:kontakt@pezula.de" className="text-accent hover:text-accent-hover transition-colors" data-id="element-233">
                  kontakt@pezula.de
                </a>
              </p>
            </div>

            <div data-id="element-234">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-235">
                Registereintrag
              </h2>
              <p data-id="element-236">
                Eintragung im Handelsregister
                <br data-id="element-237" />
                Registergericht: Amtsgericht Tostedt
                <br data-id="element-238" />
                Registernummer: HRB 210857
              </p>
            </div>

            <div data-id="element-239">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-240">
                Umsatzsteuer-ID
              </h2>
              <p data-id="element-241">
                Umsatzsteuer-Identifikationsnummer gemäß § 27a
                Umsatzsteuergesetz:
                <br data-id="element-242" />
                DE351498461
              </p>
            </div>

            <div data-id="element-243">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-244">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p data-id="element-245">
                Sven Schulte
                <br data-id="element-246" />
                Innungsstr. 5<br data-id="element-247" />
                21244 Buchholz i.d.N.
              </p>
            </div>

            <div data-id="element-248">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-249">
                Streitschlichtung
              </h2>
              <p className="text-muted" data-id="element-250">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent-hover transition-colors" data-id="element-251">
                  https://ec.europa.eu/consumers/odr
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
              <p className="text-muted mt-3" data-id="element-252">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}